import { Folder, ClientOrganizerStatus } from '@st/sdk'

export function getStatusColor(status: ClientOrganizerStatus | undefined) {
  switch (status) {
    case 'not_seen_yet':
      return 'gray'
    case 'in_progress':
      return 'yellow'
    case 'submitted':
      return 'green'
    default:
      return 'gray' // Default color
  }
}

export function getStatusLabel(status: ClientOrganizerStatus | undefined) {
  switch (status) {
    case 'not_seen_yet':
      return 'Not seen yet'
    case 'in_progress':
      return 'In progress'
    case 'submitted':
      return 'Submitted'
    default:
      return '' // Default label
  }
}
